import {
  Calendar,
  Phone,
  MapPin,
  Clock,
  Star,
  Award,
  Heart,
  Shield,
  Building2,
  Package,
  Stethoscope,
  PlusCircle,
  Baby,
  Bone,
  Brain,
  Microscope,
  ChevronRight,
  Download,
  CheckCircle,
  Trophy,
  BadgeIcon as Certificate,
  User,
  ArrowRight,
} from "lucide-react"
import { QuickAccessCard } from "../quick-access-card"



export default function QuickAccessTileswidget() {
  return (
    <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-5">
              <QuickAccessCard
                icon={<Calendar className="w-6 h-6 text-primary" />}
                title="Book Appointment"
                href="/book-appointment"
              />
              <QuickAccessCard icon={<User className="w-6 h-6 text-primary" />} title="Find Doctors" href="/doctors" />
              <QuickAccessCard
                icon={<Building2 className="w-6 h-6 text-primary" />}
                title="Services"
                href="/services"
              />
              <QuickAccessCard
                icon={<Package className="w-6 h-6 text-primary" />}
                title="Health Packages"
                href="https://pranaam365.com/"
              />
              <QuickAccessCard
                icon={<Microscope className="w-6 h-6 text-primary" />}
                title="Diagnostics"
                href="/diagnostics"
              />
              {/* <QuickAccessCard
                icon={<PlusCircle className="w-6 h-6 text-primary" />}
                title="Pharmacy"
                href="/pharmacy"
              /> */}
            </div>
          </div>
        </section>
  );
}

 